import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        criteriaId: String,
        title: String,
        products: Array,
    };

    initialize() {
        this.eventListeners = new Map();
    }

    connect() {
        // Set up click handlers for all tour cards
        this.setupProductTracking();
    }

    disconnect() {
        this.removeEventListeners();
    }

    setupProductTracking() {
        const criteriaId = this.criteriaIdValue;
        const products = this.productsValue;
        const title = this.titleValue;

        // For each product, set up click tracking
        products.forEach((product) => {
            const tourCode = product.productId;
            const elementId = `reco-${criteriaId}-tour-card-${tourCode}`;
            const element = document.getElementById(elementId);

            if (element) {
                const clickHandler = () => {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'santianoEcommerce',
                            eventCommand: 'productClick',
                            currencyCode: 'EUR',
                            productImpressionListName: `ListHP - ${title}`,
                            productList: [product],
                        });
                    } else {
                        console.warn('[ProductTracking] dataLayer not found!');
                    }
                };

                element.addEventListener('click', clickHandler);
                this.eventListeners.set(element, clickHandler);
            } else {
                console.warn(
                    `[ProductTracking] Could not find element with ID: ${elementId}`,
                );
            }
        });
    }

    removeEventListeners() {
        this.eventListeners.forEach((handler, element) => {
            if (element) {
                element.removeEventListener('click', handler);
            }
        });

        this.eventListeners.clear();
    }
}
